import { useState } from 'react';
import styles from './selectUserData.module.css';
import { FaChevronRight, FaTrash } from 'react-icons/fa';
import { IoIosCloseCircle } from "react-icons/io";
import BoxAlert from '../../../../components/boxAlert';


export default function SelectUserData({show, onClose, onSelect, onRemove, companyData, prevDataList}){
    const havePrevList = prevDataList && prevDataList.length > 0;
    const [removeAlert, setRemoveAlert] = useState({show: false, data: null});

    const handleConfirmRemove = () => {
        onRemove(removeAlert.data);
        setRemoveAlert({show: false, data: null});
    }

    return (
        <>
            {show && havePrevList && (
                <div className={styles.selectAddressAlert}>
                    <div className={styles.overflow}/>

                    <div className={styles.selectAddressBox}>
                        <div className={styles.headerSelectAddressBox} style={{backgroundColor: companyData.background_color}}>
                            <h3 className={styles.headerBoxTitle} style={{color: companyData.text_color, marginLeft: 15}}>Selecionar conta</h3>

                            <button className={styles.headerCloseButton} style={{marginRight: 15}} onClick={() => onClose()}>
                                <IoIosCloseCircle size={28} color={companyData.text_color} />
                            </button>
                        </div>

                        <div className={styles.addresBoxContainer}>
                            {prevDataList.map((item, index) => {
                                const isLast = index === prevDataList.length - 1;

                                return (
                                    <div className={styles.addressComponent} style={{borderBottom: isLast ? 'none' : '2px dashed #333'}}>
                                        <div className={styles.addressComponentDataArea}>
                                            <p className={styles.addressComponentText}>{item.name} | {item.phone}</p>
                                            {item.document ? <p className={styles.addressComponentText}>CPF: {item.document}</p> : null}
                                            <p className={styles.addressComponentText}>Endereço: {item.deliveryAddress.formattedAddress}</p>
                                        </div>

                                        <div className={styles.addressComponentActions}>
                                            <button className={styles.buttonRemoveAddress} onClick={() => setRemoveAlert({show: true, data: item})}>
                                                <FaTrash size={18} color={'#c0392b'}/>
                                            </button>

                                            <button className={styles.buttonSelectAddress} style={{backgroundColor: companyData.background_color}} onClick={() => {
                                                onSelect(item);
                                                onClose();
                                            }}>
                                                <FaChevronRight size={24} color={companyData.text_color}/>
                                            </button>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
            )}

            <BoxAlert
                show={removeAlert.show}
                title={'Remover dados'}
                text={<p>Tem certeza que deseja remover os dados de {removeAlert.data?.name}?</p>}
                showButtons={true}
                cancelButtonText={'Cancelar'}
                cancelFunction={() => setRemoveAlert({show: false, data: null})}
                confirmButtonText={'Remover'}
                confirmFunction={() => handleConfirmRemove()}
            />
        </>
    )
}